/* eslint-disable prefer-rest-params */
/* eslint-disable no-console */
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
}
export default getRandomInt;
